import { useWatch } from '@vtex/admin-ui-form'
import { useRef } from 'react'
import { useDrawerState, useFormStateContext } from 'ui'
import { transitionDurationMs } from 'ui/components/Drawer/drawer.css'
import { EMPTY_MORE_FOR_LESS_PROMOTION } from '../../../../../constants'
import {
  MoreForLess,
  type MoreForLessEffect as MoreForLessEffectType,
} from '../../../../../typings'
import { EditorMoreForLess, EditorRefType } from '../Editor'
import { ViewBenefit } from './Benefit'
import { Empty } from './Empty'
import { ViewTrigger } from './Trigger'

type Props = {
  name: string
}

const AdvancedConfigTimeout = transitionDurationMs / 3

export function ViewMoreForLess(props: Props) {
  const { name } = props

  const { form } = useFormStateContext()

  const moreForLessConfig: MoreForLessEffectType = useWatch({ form, name })

  const editorState = useDrawerState()

  const isFilled = !!moreForLessConfig.trigger && !!moreForLessConfig.benefit

  const editorRef = useRef<EditorRefType>(null)

  const handleRemove = () =>
    form.setValue(name, EMPTY_MORE_FOR_LESS_PROMOTION.moreForLess)

  const handleEdit = () => editorState.show()

  const handleEditAdvancedConfig = () => {
    editorState.show()
    editorRef.current &&
      setTimeout(() => {
        editorRef.current?.openAdvancedDrawer()
      }, AdvancedConfigTimeout)
  }

  const handleSave = (config: MoreForLessEffectType) =>
    form.setValue(name, config)

  return (
    <>
      {isFilled ? (
        <>
          <ViewTrigger
            name={`${name}.${MoreForLess.Trigger}`}
            onRemove={handleRemove}
            onEdit={handleEdit}
          />
          <ViewBenefit
            name={`${name}.${MoreForLess.Benefit}`}
            onRemove={handleRemove}
            onEdit={handleEdit}
            onEditAdvancedConfig={handleEditAdvancedConfig}
          />
        </>
      ) : (
        <Empty onAdd={handleEdit} name={name} />
      )}

      <EditorMoreForLess
        ref={editorRef}
        initialConfig={moreForLessConfig}
        onSave={handleSave}
        state={editorState}
      />
    </>
  )
}
